<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="img"
    width="1em"
    height="1em"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 576 512"
  >
    <path
      fill="currentColor"
      d="M332.7 19.85C334.6 8.395 344.5 0 356.1 0c7.5 0 14.5 3.52 19 9.502L392 32h52.1c12.7 0 25 5.06 34 14.06L496 64h56c13.3 0 24 10.75 24 24v24c0 44.2-35.8 80-80 80h-69.3l-5.1 30.5l-112-64l23.1-138.65zM448 64c-8.8 0-16 7.16-16 16s7.2 16 16 16s16-7.16 16-16s-7.2-16-16-16zm-32 192.1V480c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32V364.8c-24.9 12.3-51.2 19.2-80 19.2c-28.8 0-56-6.9-80-19.2V480c0 17.7-14.3 32-32 32H96c-17.67 0-32-14.3-32-32V249.8c-28.77-10.9-51.36-35.3-59.164-66.5l-3.88-15.5c-4.287-17.2 6.138-34.6 23.284-39.7c17.14-3.4 34.52 7 38.81 24.1l3.88 15.6c3.56 14.2 16.36 23.3 31.04 23.3H303.8l112.2 65z"
    />
  </svg>
</template>

<script>
export default {
  name: 'icon-dog',
};
</script>

<style scoped>

</style>
